import React from "react";
import { useTranslation } from "react-i18next";
import { FormBuilder, formBuilderParams } from "components/FormBuilder/FormBuilder";

const PAGE_LOCALE_KEY = "page.employees.";
const FORM_LABEL_KEY = `${PAGE_LOCALE_KEY}employeeDetail.config.fields`;

const EmployeeOptionConfig = ({ formProps }) => {
  const { t } = useTranslation();

  /** @type {Record<string, import("components/FormBuilder/lib/FormBuilderFieldBuilder").formBuilderFieldConfig>} */
  const fieldsConfig = {
    optForceUpdate: {
      fieldType: "textInput",
      fieldName: "optForceUpdate",
      label: t(`${FORM_LABEL_KEY}.optForceUpdate`),
      config: {
        rules: ["onlyInteger"]
      }
    },
    optNfclocation: {
      fieldType: "checkbox",
      fieldName: "optNfclocation",
      label: t(`${FORM_LABEL_KEY}.optNfclocation`),
    },
    geoFencingEnable: {
      fieldType: "checkbox",
      fieldName: "geoFencingEnable",
      label: t(`${FORM_LABEL_KEY}.geoFencingEnable`),
    },
    optKeepAwake: {
      fieldType: "checkbox",
      fieldName: "optKeepAwake",
      label: t(`${FORM_LABEL_KEY}.optKeepAwake`),
    },
    optPinPadSound: {
      fieldType: "checkbox",
      fieldName: "optPinPadSound",
      label: t(`${FORM_LABEL_KEY}.optPinPadSound`),
    },
    optPinPadVibrator: {
      fieldType: "checkbox",
      fieldName: "optPinPadVibrator",
      label: t(`${FORM_LABEL_KEY}.optPinPadVibrator`),
    },
    optPanToken: {
      fieldType: "checkbox",
      fieldName: "optPanToken",
      label: t(`${FORM_LABEL_KEY}.optPanToken`),
    },
    optReceiptLogo: {
      fieldType: "checkbox",
      fieldName: "optReceiptLogo",
      label: t(`${FORM_LABEL_KEY}.optReceiptLogo`),
    },
    optAutoPrintReceipt: {
      fieldType: "checkbox",
      fieldName: "optAutoPrintReceipt",
      label: t(`${FORM_LABEL_KEY}.optAutoPrintReceipt`),
    },
    optEnableScreenSaver: {
      fieldType: "checkbox",
      fieldName: "optEnableScreenSaver",
      label: t(`${FORM_LABEL_KEY}.optEnableScreenSaver`),
    },
    optAutoStartScreenSaver: {
      fieldType: "checkbox",
      fieldName: "optAutoStartScreenSaver",
      label: t(`${FORM_LABEL_KEY}.optAutoStartScreenSaver`),
    },

    screenTimeout: {
      fieldType: "textInput",
      fieldName: "screenTimeout",
      label: t(`${FORM_LABEL_KEY}.screenTimeout`),
      mandatory: true,
      config: {
        rules: ["onlyInteger"]
      }
    },
    checkCardTimeout: {
      fieldType: "textInput",
      fieldName: "checkCardTimeout",
      label: t(`${FORM_LABEL_KEY}.checkCardTimeout`),
      mandatory: true,
      config: {
        rules: ["onlyInteger"]
      }
    },
    maxPayTimes: {
      fieldType: "textInput",
      fieldName: "maxPayTimes",
      label: t(`${FORM_LABEL_KEY}.maxPayTimes`),
      mandatory: true,
      config: {
        rules: ["onlyInteger"]
      }
    },
    maxRefreshTimes: {
      fieldType: "textInput",
      fieldName: "maxRefreshTimes",
      label: t(`${FORM_LABEL_KEY}.maxRefreshTimes`),
      mandatory: true,
      config: {
        rules: ["onlyInteger"]
      }
    }
  }

  return (
    <FormBuilder.Section
      title={t(`${PAGE_LOCALE_KEY}employeeDetail.config.subtitle.option`)}
      titleVariant="h3"
      padding={formBuilderParams.formSectionLeftPadding}>
      <FormBuilder.Row itemsPerRow={3}>
        {FormBuilder.buildFields({
          formProps, fields: [
            // fieldsConfig.optForceUpdate,
            // fieldsConfig.optNfclocation,
            // fieldsConfig.geoFencingEnable,
            // fieldsConfig.optKeepAwake,
            // fieldsConfig.optPinPadSound,
            // fieldsConfig.optPinPadVibrator,
            // fieldsConfig.optPanToken,
            // fieldsConfig.optReceiptLogo,
            fieldsConfig.optAutoPrintReceipt,
            // fieldsConfig.optEnableScreenSaver,
            // fieldsConfig.optAutoStartScreenSaver,
          ]
        })}
      </FormBuilder.Row>
      <FormBuilder.Section
        title={t(`${PAGE_LOCALE_KEY}employeeDetail.config.subtitle.timeout`)}
        titleVariant="h4">
        <FormBuilder.Row itemsPerRow={3}>
          {FormBuilder.buildFields({
            formProps, fields: [
              fieldsConfig.screenTimeout,
              fieldsConfig.checkCardTimeout,
              // fieldsConfig.maxPayTimes,
              // fieldsConfig.maxRefreshTimes
            ]
          })}
        </FormBuilder.Row>
      </FormBuilder.Section>
    </FormBuilder.Section>
  );
};

export default React.memo(EmployeeOptionConfig);
